import {
	type FetchCollectibleEventsParams,
	SociosSocketEvent,
	type SocketsListener,
	useSocketEventListener,
	withRefreshStrategy
} from '@capsicum/common';
import { useMemo } from 'react';

import { UseAuctionDetailsQueryKey } from '../../data-access/queries';
import { type WebSocketPayload } from '../../models';

export const useAuctionStatusUpdateFromWS = ({
	eventsQueryKeys,
	handleAuctionStatusUpdate,
	handleAuctionUpdate
}: {
	eventsQueryKeys: Array<'auctions' | 'collectibles' | FetchCollectibleEventsParams>;
	handleAuctionStatusUpdate: () => void;
	handleAuctionUpdate: (data: WebSocketPayload) => void;
}) => {
	const cacheKeys = useMemo(
		() => [...UseAuctionDetailsQueryKey('auctionDetails'), ...(eventsQueryKeys as Array<string>)],
		[eventsQueryKeys]
	);

	const listeners = useMemo(
		() =>
			new Map<SociosSocketEvent, SocketsListener>([
				[
					SociosSocketEvent.COLLECTIBLE_BID_STATUS_UPDATED,
					withRefreshStrategy({
						cacheKeys,
						listener: handleAuctionUpdate
					})
				],
				[
					SociosSocketEvent.COLLECTIBLE_AUCTION_STATUS_UPDATED,
					withRefreshStrategy({
						cacheKeys,
						listener: handleAuctionStatusUpdate
					})
				]
			]),
		[cacheKeys, handleAuctionUpdate, handleAuctionStatusUpdate]
	);

	useSocketEventListener(listeners);
};
